import Close20 from '@carbon/icons-react/es/close/20';
import { uniqBy } from 'lodash';
import React, { FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'components/atoms/button';
import {
  updateDocResource,
  selectDocumentResourceSections,
  selectActiveDocumentInfo,
  EditorModes,
  ResourceSectionType,
  DocumentResourceType,
} from 'data/documents';
import { selectActiveStatusUpdate } from 'data/status-updates';
import { Task } from 'data/tasks';

interface Props {
  task: Task;
  className?: string;
  resourceSectionId: number;
}

export const RemoveTask: FC<Props> = ({
  task,
  className = '',
  resourceSectionId,
}) => {
  const activeStatusUpdate = useSelector(selectActiveStatusUpdate);
  const documentResources = useSelector(selectDocumentResourceSections);
  const activeDocumentDetails = useSelector(selectActiveDocumentInfo);
  const dispatch = useDispatch();
  const sectionResources =
    documentResources &&
    documentResources.find(
      (resource) => resource.resourceSectionId === resourceSectionId,
    );
  const payload =
    activeStatusUpdate && sectionResources && 'resourceIds' in sectionResources
      ? {
          projectID: activeStatusUpdate?.project.projectId,
          documentID: activeStatusUpdate?.document.documentId,
          documentSectionId: activeDocumentDetails.publicSection.id,
          sectionType: EditorModes.Public,
          resourceSections: uniqBy(
            [
              {
                resourceSectionId,
                resourceIds:
                  sectionResources?.resourceIds.filter(
                    (id) => id !== task.taskId,
                  ) || [],
                resourceSectionType: ResourceSectionType.Task,
                resourceType: DocumentResourceType.Default,
              },
              ...documentResources,
            ],
            'resourceSectionId',
          ),
        }
      : null;

  const deleteTask = () => {
    if (payload) {
      dispatch(updateDocResource(payload));
    }
  };

  return (
    <Button
      data-email-template-ignore
      className={className}
      type="text"
      icon={<Close20 />}
      size="small"
      onClick={deleteTask}
    />
  );
};
